import { render, staticRenderFns } from "./VMultiCheckbox.vue?vue&type=template&id=0c7e8139&scoped=true"
import script from "./VMultiCheckbox.vue?vue&type=script&lang=js"
export * from "./VMultiCheckbox.vue?vue&type=script&lang=js"
import style0 from "./VMultiCheckbox.vue?vue&type=style&index=0&id=0c7e8139&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7e8139",
  null
  
)

export default component.exports